'use client';

import React from 'react';
import clsx from 'clsx';
import NextLink from 'next/link';
import STYLE from './Breadcrumb.module.scss';

export interface BreadcrumbItemPropType {
    href: string;
    name: string;
    isCurrentPage?: boolean;
    isPreview?: boolean;
    nodes?: Array<{ name: string; href: string }>;
}

export const BreadcrumbItem: React.FC<BreadcrumbItemPropType> = (props) => {
    const { href, name, isCurrentPage } = props;

    return (
        <li className={clsx(STYLE.breadcrumbItem, isCurrentPage && STYLE.current)}>
            <NextLink href={href} aria-current={isCurrentPage ? 'page' : undefined}>
                {name}
            </NextLink>
        </li>
    );
};
